/* eslint-disable react/prop-types */
// added the above text for the sonarqube fix

import axios from "axios";

const downloadExcelFile = async ({
  url,
  params,
  fileName,
  dispatch,
  rejectWithValue,
  resetFunction,
}) => {
  try {
    const response = await axios.get(url, {
      params,
      withCredentials: true,
      responseType: "blob",
    });

    const downloadUrl = globalThis.URL.createObjectURL(
      new Blob([response.data])
    );

    const link = document.createElement("a");

    link.href = downloadUrl;
    link.setAttribute("download", fileName);

    document.body.appendChild(link);
    link.click();

    resetFunction(dispatch);

    return response;
  } catch (err) {
    resetFunction(dispatch);

    return rejectWithValue(err.response);
  }
};

export { downloadExcelFile };
